import React, { Component } from 'react'
import Chart from 'chart.js/auto';
import classes from "./Graph.module.css";
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import GraphZoomControls from './GraphZoomControls.js';
Chart.register(zoomPlugin);
Chart.register(annotationPlugin);


class GraphOneCurve extends Component {
    constructor(props){
        super(props);
        this.myChart = "";
        // Ref to the legend wrapper so we can align it with the plot area
        this.legendRef = React.createRef();
    }

    generateAnnotationsList(annotations, alertPoints, alertPointsReminder, min) {
        if (this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) {
        alertPoints.forEach((e, i) => {
            let new_point = {
                type: 'point',
                backgroundColor: 'transparent',
                borderColor: 'red',
                borderWidth: 1,
                pointStyle: 'triangle',
                radius: 8,
                xValue: e.x,
                yValue: e.y,
                yScaleID: 'y'
            }
            let new_label = {
                type: 'label',
                color: 'red',
                position: {
                    x: 'center',
                    y: 'end'
                },
                content: (ctx) => 'Alert',
                font: {
                    size: 10
                },
                xValue: e.x,
                yValue: e.y,
                yScaleID: 'y'
            }
            annotations["alertPoints_" + i] = new_point
            annotations["alertLabel_" + i] = new_label
        })
        }
        if (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0) {
            alertPointsReminder.forEach((e, i) => {
                let eventTime = new Date(e.x)
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'crossRot',
                    radius: 8,
                    yAdjust: -6,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => '?',
                    font: {
                        size: 10
                    },
                    yAdjust: -3,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                annotations["alertPoints_reminder_" + i] = new_point
                annotations["alertLabel_reminder_" + i] = new_label
            })
        }
        return (annotations)
    }

    // Returns pointBackgroundColor: a per-point function when pointColorZones or
    // pointColorAboveThreshold is set, otherwise a static color string.
    getPointColorFn() {
        const threshold = this.getThresholdValue(this.props.threshold);

        // Three-zone coloring (e.g. red/orange/green), matching the banner colors.
        if (this.props.pointColorZones) {
            const { red, orange, green } = this.props.pointColorZones;
            const shift = this.props.pointOrangeShift || 0;
            if (threshold === undefined) {
                return green;
            }
            return (ctx) => {
                const y = ctx.parsed?.y;
                if (y === undefined) {
                    return green;
                }
                if (y >= threshold) {
                    return red;
                }
                if (y >= threshold - shift) {
                    return orange;
                }
                return green;
            };
        }

        if (!this.props.pointColorAboveThreshold) {
            return this.props.pointColor || this.props.curve_color;
        }
        const baseColor = this.props.pointColor || this.props.curve_color;
        const aboveColor = this.props.pointColorAboveThreshold;
        if (threshold === undefined) {
            return baseColor;
        }
        return (ctx) => {
            const y = ctx.parsed?.y;
            return (y !== undefined && y > threshold) ? aboveColor : baseColor;
        };
    }

    // Threshold curves are flat horizontal lines ([{x,y},{x,y}]) so the value is y.
    getThresholdValue(threshold) {
        if (Array.isArray(threshold) && threshold.length > 0 && threshold[0] && threshold[0].y !== undefined) {
            return threshold[0].y
        }
        return undefined
    }

    // Overlay a transparent, wide hover band on each threshold line that reveals
    // a tooltip-style label with the threshold value on mouseover.
    buildThresholdAnnotations(annotations) {
        let defs = [
            { key: "thresholdHover", value: this.getThresholdValue(this.props.threshold), name: this.props.threshold_name, color: this.props.threshold_color },
            { key: "threshold2Hover", value: this.getThresholdValue(this.props.threshold2), name: this.props.threshold2_name, color: this.props.threshold2_color }
        ]
        defs.forEach((d) => {
            if (d.value === undefined) {
                return
            }
            // Keep a reference to this plain config object; enter/leave mutate
            // it directly (NOT the resolved option proxy, which would recurse).
            let annObj = {
                type: 'line',
                yMin: d.value,
                yMax: d.value,
                yScaleID: 'y',
                borderColor: 'transparent',
                borderWidth: 12,
                label: {
                    display: false,
                    content: (d.name ? d.name + ' : ' : '') + d.value,
                    position: 'start',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: '#fff',
                    borderColor: d.color,
                    borderWidth: 1,
                    borderRadius: 4,
                    padding: 6,
                    font: { size: 11, weight: 'bold' }
                },
                enter: (ctx) => { annObj.label.display = true; ctx.chart.update() },
                leave: (ctx) => { annObj.label.display = false; ctx.chart.update() }
            }
            annotations[d.key] = annObj
        })
        return annotations
    }

    componentDidMount() {
        var ctx = document.getElementById(this.props.id_graph);
        if (ctx === null) {
            ctx = this.props.new_window.document.getElementById(this.props.id_graph);
        }

        var local_max_x = 0;
        var local_min_x = 0;
        var curveDrawing = [];
        var curveThresholdDrawing = [];
        var curveThreshold2Drawing = [];
        var currentTimeDrawing  = [];
        var annotations = {}

        if(this.props.curve !== undefined){
            local_max_x             = this.props.max_x;
            local_min_x             = this.props.min_x;
            curveDrawing            = this.props.curve;
            curveThresholdDrawing   = this.props.threshold;
            curveThreshold2Drawing  = this.props.threshold2 || [];
            currentTimeDrawing      = this.props.currentTime;
            if((this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min)
            }
            annotations = this.buildThresholdAnnotations(annotations)
        }


        this.myChart = new Chart(ctx, {
            type: 'line',
            data: {
                datasets: [
                    {
                        label: this.props.curve_name,
                        data: curveDrawing,
                        showLine: this.props.showLine || false,
                        fill: false,
                        borderColor: this.props.lineColor || this.props.curve_color,
                        borderWidth: this.props.lineWidth || 2,
                        tension: this.props.lineTension || 0,
                        pointBackgroundColor: this.getPointColorFn(),
                        pointBorderWidth: 0,
                        pointRadius: (this.props.pointRadius || 4) * (this.props.pointRadiusScale || 1)
                    },
                    {
                        label: this.props.threshold_name,
                        data: curveThresholdDrawing,
                        borderColor: this.props.threshold_color,
                        borderWidth: 1,                       
                        pointBackgroundColor: this.props.threshold_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0
                    },
                    {
                        label: this.props.threshold2_name,
                        data: curveThreshold2Drawing,
                        borderColor: this.props.threshold2_color,
                        borderWidth: 1,
                        borderDash: [6, 4],
                        pointBackgroundColor: this.props.threshold2_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0
                    },
                    {
                        label: 'Maintenant',
                        data: currentTimeDrawing,
                        borderColor: "#E7DFD8",
                        pointBackgroundColor: "#E7DFD8",
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0
                    }
                  ],
            },
            options: {
                parsing: false,      
                normalized: true,
                responsive: true,
                animation: false,
                plugins: {
                    title: {
                        color: 'black',
                        font : {weight: 'bold'},
                        display: this.props.title !== undefined,
                        text: this.props.title
                    },
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x',
                            threshold: 5,
                            modifierKey: 'shift',
                        },
                        limits: {
                          x: {min: 'original', max: 'original', minRange: 3600000},
                          y: {min: 'original', max: 'original'},
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          drag: {
                            enabled: true,
                            backgroundColor: 'rgba(40, 150, 229, 0.15)',
                            borderColor: 'rgba(40, 150, 229, 0.8)',
                            borderWidth: 1,
                            threshold: 5,
                          },
                          mode: 'x',
                        }
                    },
                    annotation: {
                        annotations
                    },
                    tooltip: {
                        backgroundColor:'rgba(0,0,0,0.8)',  // black with transparency
                    },
                    legend: {
                        // Custom HTML legend is rendered under the canvas instead
                        display: false
                    }
                },
                elements: {
                    point:{
                        hitRadius: 0
                    }
                },                    
                scales: {
                    x: 
                    {
                        type: 'time',
                        min: local_min_x,
                        max: local_max_x,
                        distribution: 'series',
                        time: {
                            displayFormats: {
                                hour: 'H',                                                                                                                                
                            },
                            unit: 'hour',
                            tooltipFormat: 'MMM D - HH:mm'
                        },
                        ticks: {
                          minRotation: 0,
                          maxRotation: 0,                              
                          major: {
                            enabled: true
                          },
                          font: function(context) {
                            if (context.tick && context.tick.major) {
                              return {
                                weight: 'bold',
                              };
                            }
                          }
                        }
                    },                       
                    y: 
                    {
                        type: 'linear',                            
                        min: this.props.min,
                        max: this.props.max,
                        title: {
                            display: this.props.y_axis_title !== undefined,
                            padding: 0,
                            text: this.props.y_axis_title,
                            color: this.props.threshold_color                            
                        },
                        ticks: {
                          color: this.props.threshold_color,
                        },                        
                        grid: {
                          drawOnChartArea: false,
                        }                              
                    }
                },
            },
            plugins: [{
                // Align the HTML legend's left edge with the chart's plot area.
                // Runs on every layout (mount, update, resize); sets the DOM
                // padding directly so there is no React re-render loop.
                id: 'legendAlign',
                afterLayout: (chart) => {
                    if (this.legendRef.current && chart.chartArea) {
                        this.legendRef.current.style.paddingLeft = chart.chartArea.left + 'px';
                    }
                }
            }]
        });
    }


    updateData() {
        if((this.myChart !== undefined)&&(this.myChart.data !== undefined)){
            // Do not refresh while the user is zoomed/panned: rewriting the x
            // scale + chart.update() would snap the view back to the full range.
            // The refresh resumes once the graph is reset to its default view.
            if(this.myChart.isZoomedOrPanned && this.myChart.isZoomedOrPanned()){ return; }
            this.myChart.options.scales.x.max  = this.props.max_x;
            this.myChart.options.scales.x.min  = this.props.min_x;
            this.myChart.data.datasets[0].data = this.props.curve;
            this.myChart.data.datasets[0].pointBackgroundColor = this.getPointColorFn();
            this.myChart.data.datasets[1].data = this.props.threshold;
            this.myChart.data.datasets[2].data = this.props.threshold2 || [];
            this.myChart.data.datasets[3].data = this.props.currentTime;
            // Rebuild annotations as a fresh plain object and assign in one shot.
            // Mutating nested properties of the resolved options proxy recurses
            // (Maximum call stack), so always replace the whole annotations map.
            let annotations = {}
            if((this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min)
            }
            annotations = this.buildThresholdAnnotations(annotations)
            this.myChart.options.plugins.annotation.annotations = annotations
            this.myChart.update();
        }
    }

    // Light, professional legend box shown under the graph.
    // Only renders entries whose threshold is defined; nothing if none are.
    renderThresholdLegend() {
        if (this.props.showThresholdLegend !== true) {
            return null
        }

        let items = []
        if (this.props.threshold !== undefined && this.props.threshold_name !== undefined) {
            items.push({ name: this.props.threshold_name, color: this.props.threshold_color, dashed: false })
        }
        if (this.props.threshold2 !== undefined && this.props.threshold2_name !== undefined) {
            items.push({ name: this.props.threshold2_name, color: this.props.threshold2_color, dashed: true })
        }
        if (items.length === 0) {
            return null
        }

        const boxStyle = {
            display: "inline-flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "13px",
            margin: "6px auto 3px",
            padding: "4px 12px",
            background: "#fafbfc",
            border: "1px solid #e8ebef",
            borderRadius: "6px",
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.06)",
            fontSize: "9px",
            fontWeight: 500,
            color: "#475467"
        }

        return (
            <div ref={this.legendRef} style={{ width: "100%", textAlign: "left", boxSizing: "border-box" }}>
                <div style={boxStyle}>
                    {items.map((item, i) => (
                        <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                            <span style={{ display: "inline-block", width: "15px", height: 0, borderTop: "1.5px " + (item.dashed ? "dashed" : "solid") + " " + item.color }} />
                            {item.name}
                        </span>
                    ))}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
                <div style={{ flex: "1 1 auto", minHeight: 0, position: "relative", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <canvas
                        style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
                        id={this.props.id_graph}
                        ref={this.chartRef}
                    >
                    {
                        this.updateData()
                    }
                    </canvas>
                </div>
                <GraphZoomControls
                    getChart={() => this.myChart}
                    onEnlarge={this.props.onEnlarge}
                />
                {this.renderThresholdLegend()}
            </div>
        )
    }
}
export default (GraphOneCurve)
